<template>
  <div class="login-header">
    <v-row>
      <div class="pt-3 pl-3">
        <img src="@/assets/logo.svg" height="40" alt="logo" />
      </div>
      <!--<div class="title pt-4">
        <h2>

          <span >{{ $t('message.page.customer', { value: 'default' }) }}</span>
          <span style="color:#7FC7B2">{{ $t('message.page.portal', { value: 'default' }) }}</span>
        </h2>
      </div>-->
      <div class="switch-customer" v-show="getterAdUser" v-if="showCustomer">
        <v-autocomplete
          :label="$t('message.selectCustomer', { value: 'default' })"
          dense
          solo
          :items="getterClient"
          item-text="name"
          item-value="customernum"
          @change="commitCustomer"
          v-model="selectedCustomer"
        ></v-autocomplete>
      </div>

      <div class="locale">
        <switch-locale></switch-locale>
      </div>
    </v-row>
  </div>
</template>

<script>
import SwitchLocale from "./SwitchLocale";
import { mapGetters, mapMutations } from "vuex";
export default {
  props: {
    showCustomer : {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      selectedCustomer: "",
    };
  },
  methods: {
    ...mapMutations("auth", {
      saveCustomer: "setCurrentClient",
    }),

    mySort() {
      this.getterClient.sort((a, b) => {
        return a.client?.name.localeCompare(b.client?.name);
      });
    },
    commitCustomer(value) {
      this.saveCustomer(value);
    },

    loadCustomer() {
      this.selectedCustomer = this.getterCustomer;
    },
  },
  name: "PortalSysbar",
  components: {
    SwitchLocale,
  },
  mounted() {
    this.loadCustomer();
    this.mySort();
  },
  computed: {
    ...mapGetters("auth", {
      getterAdUser: "isAdUser",
      getterClient: "getClients",
      getterCustomer: "getCurrentClient",
    }),
  },
};
</script>

<style scoped>
.login-header {
  margin: 0px auto;
  padding-left: 10px;
  padding-top: 10px;
  background-color: #fff;
  display: inline-flex;
  position: fixed;
  width: 100%;
  z-index: 99;
  height: 60px;
  display: inline-flex;
}

.locale {
  width: 80px;
  z-index: 2000;
  position: absolute;
  right: 20px;
  top: 9px;
}

.title {
  padding-left: 145px;
  color: #00475a;
  text-transform: uppercase;
}

.switch-customer {
  width: 200px;
  float: right;
  top: 9px;
  position: absolute;
  right: 120px;
  z-index: 2000;
}
</style>
